/**
 * Created by servandomendoza on 8/20/15.
 */
var ENCUENTRO = ENCUENTRO || {};

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

ENCUENTRO.user = {
    remove: function (user, callback) {
        var qPromise = $.ajax({
            type: "DELETE",
            url: '/user/' + user.id,
            data: user,
            async: true,
            cache: false
        });

        return callback(qPromise);
    }
};


ENCUENTRO.program = {
    remove: function (program, callback) {
        var qPromise = $.ajax({
            type: "DELETE",
            url: '/programs/' + program.id,
            data: program,
            async: true,
            cache: false
        });

        return callback(qPromise);
    }
};

ENCUENTRO.payment = {
    remove: function (paymentId, callback) {
        var qPromise = $.ajax({
            type: "DELETE",
            url: '/payments/' + paymentId,
            data: {
                'id' : paymentId
            },
            async: true,
            cache: false
        });

        return callback(qPromise);
    }
};